import React, { useMemo } from 'react';
import { CardHcdAvailabilityOutputDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { Typography } from '@kiiwi/ui';
import Link from 'next/link';
import useResponsive from '@/src/hooks/useResponsive';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';
import { useTranslation } from '@/src/i18n';

interface ProCardNameProps {
  item: CardHcdAvailabilityOutputDTO;
  onClick?: (e: React.MouseEvent) => void;
}

const ProCardName = ({ item, onClick }: ProCardNameProps) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const {
    url,
    favorite,
    referring,
    practitioner: { fullName: pratName } = {},
    center: { id: centerId, name: centerName } = {},
  } = item;

  const fullName = pratName || centerName;
  const content = useMemo(
    () => (
      <a
        className="flex gap-2 hover:underline"
        title={fullName}
        aria-label={fullName}
        href="#"
        onClick={onClick}
      >
        <Typography
          variant="body-1"
          className="w-full truncate font-semibold leading-6 text-neutral-primary sm:text-lg lg:leading-7"
        >
          {fullName}
        </Typography>

        {favorite && !referring && (
          <FontAwesomeIcon
            name="star:solid"
            className="h-5 w-5 flex-shrink-0"
            color="#F6E05E"
            aria-label={t('in_favorites')}
          />
        )}

        {referring && (
          <FontAwesomeIcon
            name="heart:solid"
            className="h-5 w-5 flex-shrink-0"
            color="#f68092"
            aria-label={t('my_attending_physician')}
          />
        )}
      </a>
    ),
    [fullName, centerId],
  );

  return isMobile ? (
    content
  ) : (
    <Link
      href={{
        pathname: url,
        query: { ...(centerId ? { centerId } : {}) },
      }}
      passHref
      legacyBehavior
    >
      {content}
    </Link>
  );
};

export default ProCardName;
